import PropTypes from 'prop-types';
import React from 'react';
import { Label } from 'semantic-ui-react';
import './styles.css';

const CustomLabel = ({
  enableIcon,
  onClickIcon,
  children,
  altIcon = 'Adicionar',
  classNameIcon = 'config-icon-plus',
  titleIcon = 'Adicionar'
}) => (
  <div className="label-wrapper">
    {enableIcon ? (
      <span className="wrapper-title-icon-plus">
        <Label className="text-label">{children}</Label>
        <input
          type="button"
          className={classNameIcon}
          alt={altIcon}
          onClick={onClickIcon}
          title={titleIcon}
        />
      </span>
    ) : (
      <Label className="text-label">{children}</Label>
    )}
  </div>
);

CustomLabel.propTypes = {
  children: PropTypes.string.isRequired,
  enableIcon: PropTypes.bool,
  onClickIcon: PropTypes.func
};

CustomLabel.defaultProps = {
  enableIcon: false,
  onClickIcon: () => {
    throw Error('NotImplemented');
  }
};

export default CustomLabel;
